(ns vit-configurator.config
  #?(:clj (:require [environ.core :as e]))
  #?(:cljs (:require-macros [vit-configurator.config :refer [optional-env-var required-env-var]])))

#?(:clj
   (do
     (defmacro optional-env-var
       "For use at compile time.
       Pulls a var from the environment and returns it."
       [name]
       (e/env name))

     (defmacro required-env-var [name]
       (if-let [value (e/env name)]
         value
         (throw (Exception. (str "Missing required env var: " name)))))))

#?(:cljs
   (do
     (def debug?
       ^boolean goog.DEBUG)

     (defn get-vit-preview-env []
       (when-let [vit-preview-env (optional-env-var :vit-preview-env)]
         {:vit-preview-env vit-preview-env}))))
